{
  "welcome": "स्वागत है",
  "instructions": "चेक-इन प्रक्रिया शुरू करने के लिए नीचे टैप करें।",
  "startCheckIn": "चेक-इन शुरू करें",
  "missingWarehouseTitle": "वेयरहाउस अनुपस्थित",
  "missingWarehouseMessage": "लिंक अमान्य है, इसमें वेयरहाउस आईडी होना आवश्यक है",
  "recaptchaAttribution": "यह साइट reCAPTCHA द्वारा सुरक्षित है और Google की {privacyPolicy} और {termsOfService} लागू होती हैं।",
  "recaptchaPrivacyPolicy": "गोपनीयता नीति",
  "recaptchaTermsOfService": "सेवा की शर्तें",
  "lookupTitle": "अपनी अपॉइंटमेंट खोजने के लिए संदर्भ संख्या या पुष्टि संख्या जोड़ें",
  "referenceNumberLabel": "संदर्भ संख्या या पुष्टि संख्या",
  "referenceNotFoundError": "संदर्भ या पुष्टि संख्या किसी भी मान्य अपॉइंटमेंट से मेल नहीं खाती।",
  "checkIn": "चेक-इन करें",
  "loadTypeLabel": "लोड प्रकार",
  "directionLabel": "दिशा",
  "operationLabel": "संचालन",
  "dockLabel": "डॉक",
  "orDivider": "या",
  "noReferenceTitle": "मेरे पास पुष्टि संख्या नहीं है",
  "noReferenceDescription": "मानक चेक-इन प्रक्रिया का उपयोग करके बिना अपॉइंटमेंट के आगे बढ़ें।",
  "checkInWithoutAppointment": "बिना अपॉइंटमेंट के चेक-इन करें",
  "readyToCheckInTitle": "चेक-इन के लिए तैयार हैं?",
  "readyToCheckInDescription": "शुरू करने के लिए नीचे टैप करें। आप अगली स्क्रीन पर अपना विवरण दर्ज करेंगे।",
  "referenceRequiredHint": "इस स्थान पर चेक-इन करने के लिए संदर्भ संख्या आवश्यक है।",
  "haveAppointment": "मेरे पास अपॉइंटमेंट है",
  "direction": {
    "inbound": "इनबाउंड",
    "outbound": "आउटबाउंड",
    "inOut": "इनबाउंड और आउटबाउंड",
    "load": "लोडिंग",
    "unload": "अनलोडिंग"
  },
  "operation": {
    "live": "लाइव",
    "drop": "ड्रॉप",
    "other": "अन्य"
  }
}
